var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.457031,
    y: 0.481445,
    width: 21.044,
    height: 21.044,
    rx: 2.09759,
    fill: "#0096FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.46892 12.6762C5.95355 12.6762 4.7251 11.4478 4.7251 9.93239C4.7251 8.41702 5.95355 7.18857 7.46892 7.18857C8.98429 7.18857 10.2127 8.41702 10.2127 9.93239L10.2127 12.6762L7.46892 12.6762Z",
    fill: "#FFC814"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5245 12.6762C13.0091 12.6762 11.7806 11.4478 11.7806 9.93239C11.7806 8.41702 13.0091 7.18857 14.5245 7.18857C16.0398 7.18857 17.2683 8.41702 17.2683 9.93239L17.2683 12.6762L14.5245 12.6762Z",
    fill: "#FFC814"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7004 12.6762H17.2683V15.812C16.4023 15.812 15.7004 15.11 15.7004 14.2441V12.6762Z",
    fill: "#FFC814"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64484 12.6762H10.2127V15.812C9.34681 15.812 8.64484 15.11 8.64484 14.2441V12.6762Z",
    fill: "#FFC814"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatement);
export default __webpack_public_path__ + "static/media/statement.f739c02a50492b53511775440c934955.svg";
export { ForwardRef as ReactComponent };